import React from 'react';
import { AutocompleteState, VNode } from '@algolia/autocomplete-js';
import { BaseItem } from '@algolia/autocomplete-core';
import styles from './SuggestedSearches.module.scss';

interface Props {
	querySuggestionsPlugin: VNode;
	recentSearchesPlugin: VNode;
	state: AutocompleteState<BaseItem>;
}

export const SuggestedSearches: React.FC<Props> = ({
	querySuggestionsPlugin,
	recentSearchesPlugin,
	state,
}) => {
	const hasRecentSearches = state.collections.some(
		({ source }) => source.sourceId === 'recentSearchesPlugin'
	);

	return (
		<>
			{(hasRecentSearches || querySuggestionsPlugin) && (
				<div className={styles.aaPanelSectionLeft}>
					{hasRecentSearches && recentSearchesPlugin}
					{querySuggestionsPlugin}
				</div>
			)}
		</>
	);
};
